import { render, staticRenderFns } from "./collectStep1.vue?vue&type=template&id=3f80db0e&scoped=true&"
import script from "./collectStep1.vue?vue&type=script&lang=ts&"
export * from "./collectStep1.vue?vue&type=script&lang=ts&"
import style0 from "./collectStep1.vue?vue&type=style&index=0&id=3f80db0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80db0e",
  null
  
)

export default component.exports